export class WebFormCheckout {
    clientId: number;
    countryISO: string;
    actionType:string;
    poNumber:string;
    invoiceEmail:string;
    orderList: OrderItemDetails[];
}

export class OrderItemDetails {

    deliver_To_Full_Name: string;
    deliver_To_First_Name: string;
    deliver_To_Last_Name: string;
    deliver_To_Email: string;
    quantity: string;
    sku: string;
    order_Item_Name: string;
    
}